import QRCode from "react-qr-code"

export default function ({ value }: { value: string }) {


    return <div className="w-48 h-48">
        <QRCode value={value} style={{ height: "auto", maxWidth: "100%", width: "100%" }} />
    </div>
}